export default "__VITE_ASSET__DfTf_mVt__"